import { l } from 'app/scripts/lib/localize';
import { templates } from 'app/scripts/views/internal/templates';
import { View } from 'app/scripts/views/internal/view';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { ConfirmTemplate } from 'app/scripts/views/templates/ConfirmTemplate';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

const lazyDefaults = (original, defaults) => {
  const target = { ...original };

  Object.keys(defaults)
    .filter((key) => !(key in target))
    .forEach((key) => {
      const valueFunction = defaults[key];
      target[key] = valueFunction();
    });

  return target;
};

const makeOpts = (key, oldOpts) => {
  const opts = lazyDefaults(oldOpts, {
    title() {
      return l(['confirm', key, 'title'], oldOpts.templateData);
    },
    // We are currently assuming that translations are safe HTML
    html() {
      return l(['confirm', key, 'text'], oldOpts.templateData);
    },
    confirmText() {
      return l(['confirm', key, 'confirm'], oldOpts.templateData);
    },
  });

  if ('fxCancel' in opts && !('cancelText' in opts)) {
    opts.cancelText = l(['confirm', key, 'cancel'], oldOpts.templateData);
  }

  return opts;
};

class Confirm extends View {
  constructor({
    model,
    text,
    html,
    elem,
    top,
    confirmText,
    confirmBtnClass,
    confirmBtnTestId,
    cancelText,
    title,
    template,
    templateData,
    data,
    fxConfirm,
    fxCancel,
    popOnClick,
    popDepth,
    maxWidth,
  }) {
    super(...arguments);

    this._events = {
      'click .js-confirm': 'confirm',
      'click .js-cancel': 'cancel',
    };

    this.model = model;
    this.elem = elem;
    this.top = top;
    this.title = title;
    this.template = template;
    this.templateData = templateData;
    this.popOnClick = popOnClick;
    this.popDepth = popDepth;
    if (!this.template) {
      this.template = ConfirmTemplate;
    }
    if (!confirmBtnTestId) {
      confirmBtnTestId = '';
    }
    this.confirm = this._handleClick(fxConfirm);
    this.cancel = fxCancel ? this._handleClick(fxCancel) : function () {};
    this.data = {
      text,
      html,
      confirmText,
      confirmBtnClass,
      confirmBtnTestId,
      cancelText,
      ...(data || {}),
    };
    if (!this.templateData) {
      this.templateData = {};
    }
    this.maxWidth = maxWidth;

    this.delegateEvents(this._events);
  }

  static toggle(key, opts) {
    if (arguments.length === 1) {
      opts = key;
    } else {
      opts = makeOpts(key, opts);
    }

    return PopOver.toggle({
      elem: opts.elem,
      top: opts.top,
      alignRight: opts.alignRight,
      view: this,
      options: opts,
    });
  }

  static pushView(key, opts) {
    if (arguments.length === 1) {
      opts = key;
    } else {
      opts = makeOpts(key, opts);
    }

    return PopOver.pushView({
      view: this,
      options: opts,
    });
  }

  getViewTitle() {
    return this.title;
  }

  render() {
    this.$el.html(
      templates.fill(
        this.template,
        this.data,
        {},
        { member: templates.member },
      ),
    );
    setTimeout((e) => {
      this.$el.find('.js-confirm').focus();
      return 0;
    });
    return this;
  }

  _handleClick(fx) {
    return (e) => {
      stopPropagationAndPreventDefault(e);

      if (this.popOnClick) {
        PopOver.popView(this.popDepth);
      } else {
        PopOver.hide();
      }

      if (typeof fx === 'function') {
        fx(e);
      }
      this.remove();
      return false;
    };
  }
}

export { Confirm };
